// Prévia de fonte SÓ por ?fonte=b|c (piloto do M-B B1.11). Sem o parâmetro, nada muda — produção inclusive.
// Guarda em sessionStorage para a prévia seguir ao navegar entre telas da mesma aba.
const FONTES = {
  b: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Condensed:wght@600&display=swap',
  c: 'https://fonts.googleapis.com/css2?family=Archivo:wdth,wght@112,600&display=swap',
};

export function aplicarPreviaFonte() {
  let f = null;
  try {
    f = new URLSearchParams(window.location.search).get('fonte') || sessionStorage.getItem('previa_fonte');
    if (f) sessionStorage.setItem('previa_fonte', f);
  } catch { /* storage bloqueado: só a URL vale */ }
  if (!FONTES[f]) return;
  document.documentElement.dataset.fonte = f;
  const l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = FONTES[f];
  document.head.appendChild(l);
}
